import Service from '../Service';
import {
  ResponseErrorBody,
  LoginForm,
  RequestParamsLogin,
  ResponseSuccessBodyLogin,
  RequestParamsLoginWithInternalUrl
} from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export default async function(params: LoginForm) {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsLogin>('/api/auth/login')
      .setMethod('POST')
      .setPayload(params)
  );
  const service = new Service<ResponseSuccessBodyLogin, ResponseErrorBody>(
    request
  );
  return await service.send();
}

export const LoginWebToken = async (webtoken: string) => {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsLogin>(`/api/auth/login/${webtoken}`).setMethod(
      'POST'
    )
  );
  const service = new Service<ResponseSuccessBodyLogin, ResponseErrorBody>(
    request
  );
  return await service.send();
};

export const PersonalizedLogin = async (
  webtoken: string,
  internalUrl: string
) => {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsLogin>(
      `/api/auth/link/${webtoken}/url/${internalUrl}`
    ).setMethod('POST')
  );
  const service = new Service<ResponseSuccessBodyLogin, ResponseErrorBody>(
    request
  );
  return await service.send();
};

export const NonPersonalizedLogin = async (internalUrl: string) => {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsLogin>(
      `/api/auth/common/${internalUrl}`
    ).setMethod('POST')
  );
  const service = new Service<ResponseSuccessBodyLogin, ResponseErrorBody>(
    request
  );
  return await service.send();
};

export const PersonalizedLoginWithAgreement = async (
  webtoken: string,
  internalUrl: string
) => {
  const request = await addFingerprintToRequest(
    new Request<RequestParamsLoginWithInternalUrl>(
      `/api/auth/link/${webtoken}/url/${internalUrl}`
    )
      .setMethod('POST')
      .setPayload({ agreements: ['privacy_policy_domrf'] })
  );
  const service = new Service<ResponseSuccessBodyLogin, ResponseErrorBody>(
    request
  );
  return await service.send();
};
